import { GetInstallmentsParams, reportsService } from '@/services';
import { useQuery } from '@tanstack/react-query';

/**
 * Lista paginada do Extrato de Parcelas. Só dispara quando o período
 * (obrigatório) está preenchido — evita chamadas 400 antes da escolha.
 */
export function useInstallments(params: GetInstallmentsParams = {}) {
  const enabled = Boolean(params.periodFrom && params.periodTo);

  return useQuery({
    queryKey: ['installments', params],
    enabled,
    queryFn: async () => {
      const response = await reportsService.listInstallments(params);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Não foi possível carregar o extrato de parcelas.');
      }
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}
